import { m } from '@sohanscript/i18n';
import { toast } from 'sonner';

export type InspectorStatus = 'reading' | 'partial' | 'ready';

/** Zoom limits relative to the fitted (contain) view. */
export const ZOOM_MIN_FACTOR = 0.25;
export const ZOOM_MAX_FACTOR = 8;
export const ZOOM_STEP_FACTOR = 0.25;
/**
 * Wheel zoom sensitivity: the scale is multiplied by `exp(-delta * factor)`,
 * so the zoom keeps the same perceived speed at every zoom level.
 */
export const WHEEL_ZOOM_SENSITIVITY = 0.0015;
export const PALETTE_SKELETON = [
	'one',
	'two',
	'three',
	'four',
	'five',
] as const;
/** Scale deltas below this are noise, not a zoom change worth a re-render. */
export const SCALE_EPSILON = 0.0005;

// NOTE: the sidebar is 400px wide, so the surface (not the viewport) has to be
// wide enough to leave the image a readable stage. A viewport-wide dialog at
// 78vw crosses this at ~1230px, and a fullscreen window at this width.
export const SIDEBAR_MIN_SURFACE_WIDTH = 1200;

export function escapeAttribute(value: string) {
	return value
		.replaceAll('&', '&amp;')
		.replaceAll('<', '&lt;')
		.replaceAll('>', '&gt;')
		.replaceAll('"', '&quot;');
}

export function useCopyFeedback() {
	return {
		onCopied: (label?: string) =>
			toast.success(m.image_inspector_copied({ label: label ?? '' })),
		onCopyFailed: () => toast.error(m.image_inspector_clipboard_unavailable()),
	};
}
